import routes from 'routes/routes'
import { UserTypes } from 'types/users'

export const navigationItems = [
    { key: 1, i18nKey: 'main_page', path: routes.home },
    { key: 2, i18nKey: 'search', path: routes.search },
    { key: 3, i18nKey: 'news', path: routes.news },
    { key: 4, i18nKey: 'dashboard', path: routes.dashboard, authOnly: true },
    {
        key: 5,
        i18nKey: 'uploading',
        path: routes.upload,
        authOnly: true,
        roles: [UserTypes.ADMIN],
    },
    {
        key: 6,
        i18nKey: 'panel',
        path: routes.adminPanel,
        authOnly: true,
        roles: [UserTypes.ADMIN],
    },
    {
        key: 7,
        i18nKey: 'analytics',
        path: routes.analytics,
        authOnly: true,
        roles: [UserTypes.ADMIN],
    },
    { key: 8, i18nKey: 'help', path: routes.help },
    { key: 9, i18nKey: 'contact', path: routes.contact },
]
